import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SchemaOrg, { buildWebSiteSchema } from "@/components/base/SchemaOrg";
import HeroSection from "./components/HeroSection";
import CTASection from "./components/CTASection";
import CategoryGrid from "./components/CategoryGrid";
import SEOArticlesSection from "./components/SEOArticlesSection";
import ValueSection from "./components/ValueSection";
import TrustSection from "./components/TrustSection";

export default function Home() {
  return (
    <>
      <SchemaOrg type="WebSite" data={buildWebSiteSchema() as Record<string, unknown>} />
      <Navbar />
      <main>
        <HeroSection />
        <CTASection />
        <CategoryGrid />
        <SEOArticlesSection />
        <ValueSection />
        <TrustSection />
      </main>
      <Footer />
    </>
  );
}